import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Ventasmovil from './pages/Ventasmovil';
import Ejecutivos from './pages/Ejecutivos';
import EjecutivoDetalle from "./pages/EjecutivoDetalle";
import EstadisticasFijo from './pages/EstadisticasFijo';
import Layout from './components/Layout';
import EstadisticasMasivo from "./pages/EstadisticasMasivo";
import EstadisticasPyme from "./pages/EstadisticasPyme";
import EstadisticasSSPP from "./pages/EstadisticasSSPP";

function App() {
  const isAuthenticated = !!localStorage.getItem("token");

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/login" element={<Login />} />

        {isAuthenticated && (
          <Route element={<Layout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/ventasmovil" element={<Ventasmovil/>} />
            <Route path="/ejecutivos" element={<Ejecutivos/>} />
            <Route path="/ejecutivos/:id" element={<EjecutivoDetalle />} />
            <Route path="/estadisticas" element={<EstadisticasFijo />} />

            <Route path="/estadisticas/masivo" element={<EstadisticasMasivo />} />
            <Route path="/estadisticas/pyme" element={<EstadisticasPyme />} />
            <Route path="/estadisticas/sspp" element={<EstadisticasSSPP />} />
          </Route>
        )}

        <Route path="*" element={<h1 className="text-white text-center mt-20 text-2xl">404 - Página no encontrada</h1>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
